import { FieldDesc } from '90.quickConnect.Models/models';

export function fieldIsVisible({ items, isVisible }: FieldDesc): boolean {
  if (!items || items.length === 0) return isVisible;

  return items.some(fieldIsVisible);
}
